import { createSlice } from "@reduxjs/toolkit";

const initialCompanyState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  companyForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const companySlice = createSlice({
  name: "companies",
  initialState: initialCompanyState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getCompanyById
    companyFetched: (state, action) => {
      state.actionsLoading = false;
      state.companyForEdit = action.payload.companyForEdit;
      state.floorPlans = action.payload.companyForEdit.floorPlans;
      state.error = null;
    },
    // getCompanyChart
    companyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.companyChart = action.payload.companyChart;
      state.error = null;
    },
    // getCompanyChart
    companyHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.companyChartHour = action.payload.companyChartHour;
      state.error = null;
    },
    // getCompanyChart
    companyHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.companyChartHourZone = action.payload.companyChartHourZone;
      state.error = null;
    },
    // get list data
    companiesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.companyForEdit = undefined;
    },
    // createCompany
    companyCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateCompany
    companyUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // companyDeleted
    companyDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
  },
});
